import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_autocomplete_filled = _resolveComponent("v-autocomplete-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "header" }, "Informations de l'entreprise", -1)),
    _createVNode(_component_v_form, {
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.valid) = $event)),
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { dense: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Siret",
                  type: "number",
                  modelValue: _ctx.company.siret,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company.siret) = $event)),
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInputSetTruncatedSiret(_ctx.company.siret))),
                  onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSiretValided = false)),
                  rules: _ctx.siretRules,
                  error: _ctx.isSiretError,
                  "error-messages": _ctx.siretErrorMessage,
                  "hide-details": !_ctx.isSiretError
                }, null, 8, ["modelValue", "rules", "error", "error-messages", "hide-details"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Siren",
                  type: "number",
                  modelValue: _ctx.company.siren,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company.siren) = $event)),
                  readonly: _ctx.isSiretValided,
                  error: _ctx.isSirenError,
                  "error-messages": _ctx.sirenErrorMessage,
                  "hide-details": !_ctx.isSirenError
                }, null, 8, ["modelValue", "readonly", "error", "error-messages", "hide-details"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Numéro de TVA",
                  modelValue: _ctx.company.vatNumber,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.vatNumber) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { dense: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Nom",
                  modelValue: _ctx.company.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company.name) = $event)),
                  readonly: _ctx.isSiretValided
                }, null, 8, ["modelValue", "readonly"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Nom légal",
                  modelValue: _ctx.company.legalUnitName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.company.legalUnitName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Nom commercial",
                  modelValue: _ctx.company.tradeName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.company.tradeName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "8" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Adresse",
                  modelValue: _ctx.company.address,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company.address) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Code Postal",
                  modelValue: _ctx.company.postalCode,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.company.postalCode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Ville",
                  modelValue: _ctx.company.city,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.company.city) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  label: "Pays",
                  modelValue: _ctx.company.country,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.company.country) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_autocomplete_filled, {
                  modelValue: _ctx.company.legalForm,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.company.legalForm) = $event)),
                  items: _ctx.legalForms,
                  "item-value": "id",
                  "rules:": _ctx.legalFormsRules,
                  error: _ctx.isLegalFormError,
                  "error-messages": _ctx.legalFormErrorMessage,
                  disabled: _ctx.isAutomaticLegalForm,
                  "hide-details": !_ctx.isLegalFormError,
                  "item-title": _ctx.formatItemTitle,
                  label: "Forme juridique"
                }, null, 8, ["modelValue", "items", "rules:", "error", "error-messages", "disabled", "hide-details", "item-title"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select_filled, {
                  multiple: "",
                  chips: "",
                  modelValue: _ctx.company.salesAccounts,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.company.salesAccounts) = $event)),
                  items: _ctx.availableSalesAccounts,
                  "item-value": "name",
                  "hide-details": "auto",
                  label: _ctx.$t('settings.salesAccountingAccount'),
                  density: "compact",
                  "item-title": (item) => item.description
                }, null, 8, ["modelValue", "items", "label", "item-title"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_combobox_filled, {
                  chips: "",
                  modelValue: _ctx.company.activities,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.company.activities) = $event)),
                  items: _ctx.allActivities,
                  "item-value": "name",
                  multiple: "",
                  "item-title": "name",
                  label: "Code NAF",
                  disabled: _ctx.isAutomaticActivities
                }, null, 8, ["modelValue", "items", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}